import { Injectable } from '@angular/core'
import { Logger } from '../../../logger.service'
import { ApiService } from '../../general/api.service'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import { Purchase } from '../../../models'
import { HttpParams } from '@angular/common/http'
import { LocalStorageService } from '@hmp/helper'

const log = new Logger('PurchaseService')

/**
 * Đây là services dành cho PurchaseService
 */
@Injectable({ providedIn: 'root' })
export class PurchaseService {
  constructor(
    private apiService: ApiService,
    private storage: LocalStorageService
  ) {}
  /**
   * Khai báo tất cả các path sẻ sử dụng
   */
  private _apiPath = {
    list: 'purchase/purchase_entity',
    detail: 'purchase/purchase_entity',
  }

  /**
   * Lấy tất cả Purchase
   */
  getAll(params?: any): Observable<any> {
    let pa = new HttpParams().set(
      'parameters[purchase_business_id]',
      this.storage.getActiveLocalBusinessID()
    )
    if (params) {
      Object.keys(params).forEach(function(key) {
        pa = pa.append(key, params[key])
      })
    }

    return this.apiService.get<any>(this._apiPath.list, pa).pipe(
      map(data => {
        log.debug('sdsdsdxxx', pa)
        return data
      })
    )
  }

  /**
   * Lấy thông tin chi tiết của Purchase dưạ vào @id
   * @param Id ID của Purchase
   */
  getDetail(id: string): Observable<Purchase> {
    return this.apiService.get<Purchase>(`${this._apiPath.detail}/${id}`).pipe(
      map(data => {
        log.debug(data)
        return data
      })
    )
  }

  /**
   * Tạo Purchase
   * @param res Thông tin Purchase
   */
  create(res: Purchase): Observable<any> {
    res.pid = null
    return this.apiService.post(this._apiPath.detail, res).pipe(
      map(data => {
        log.debug(data)
        return data
      })
    )
  }

  /**
   * Chỉnh sửa thông tin Purchase
   *
   * @param res Thông tin Purchase muốn chỉnh sửa
   */
  edit(res: Purchase): Observable<any> {
    return this.apiService.put(`${this._apiPath.detail}/${res.pid}`, res).pipe(
      map(data => {
        return data
      })
    )
  }

  /**
   * Xóa thông tin Purchase
   *
   * @param id Xóa Purchase bằng Purchase ID
   */
  delete(id): Observable<any> {
    return this.apiService.delete(`${this._apiPath.detail}/${id}`).pipe(
      map(data => {
        log.debug(data)
        return data
      })
    )
  }
}
